import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapAppsAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.platformConfiguration?.saveOIDCandOAuthAppsData, currentState.platformConfiguration?.saveOIDCandOAuthAppsData, {
    successEventName: "apps_created_new_app",
    errorEventName: "apps_got_app_error",
    trackedEventNames: ["apps_created_new_app", "apps_got_app_error"]
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.updateOIDCandOAuthAppsData, currentState.platformConfiguration?.updateOIDCandOAuthAppsData, {
    successEventName: "apps_configured_app_successfully",
    errorEventName: "apps_got_app_error",
    trackedEventNames: ["apps_configured_app_successfully", "apps_enabled_connections", "apps_got_app_error"]
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.deleteOIDCandOAuthAppsData, currentState.platformConfiguration?.deleteOIDCandOAuthAppsData, {
    successEventName: "apps_deleted_app",
    errorEventName: "apps_got_app_error",
    trackedEventNames: ["apps_deleted_app", "apps_got_app_error"]
  })
];
